<template>
  <div class="home">
    <h3 class="title">วิธีการปรับความเข้มข้นสารน้ำ (แบบเติม NaCl)</h3>
    <ul id="menu">
      <li>
        <input type="range" min="0" max="10" step="2.5" v-model="d1" />
        <input class="input" type="integer" v-model="d1" size="3px" />%D <br />
      </li>
      <li>
        <span class="input">
          <input class="input" type="radio" v-model="nacl" value="0" />
          <label for="w">W</label>
          <input type="radio" v-model="nacl" value="0.9" />
          <label for="S">S</label>
          <input type="radio" v-model="nacl" value="0.45" />
          <label for="N/2">N/2</label>
          <input type="radio" v-model="nacl" value="0.3" />
          <label for="N/3">N/3</label>
          <input type="radio" v-model="nacl" value="0.225" />
          <label for="N/4">N/4</label>
          <input type="radio" v-model="nacl" value="0.18" />
          <label for="N/5">N/5</label>
        </span>
      </li>
    </ul>
    <img id="arrow" src="../assets/downarrow.png" />
    <ul id="menu">
      <li>
        <input type="range" min="5" max="30" step="2.5" v-model="d2" />
        <input class="input" type="integer" v-model="d2" size="4px" />%D <br />
      </li>
      <li>
        <span class="input">
          <input class="input" type="radio" v-model="nt" value="0" />
          <label for="w">W</label>
          <input type="radio" v-model="nt" value="0.9" />
          <label for="S">S</label>
          <input type="radio" v-model="nt" value="0.45" />
          <label for="N/2">N/2</label>
          <input type="radio" v-model="nt" value="0.3" />
          <label for="N/3">N/3</label>
          <input type="radio" v-model="nt" value="0.225" />
          <label for="N/4">N/4</label>
          <input type="radio" v-model="nt" value="0.18" />
          <label for="N/5">N/5</label>
        </span>
      </li>

      <li>
        <input class="input" type="integer" v-model="vt" size="5px" />
        <span class="input">ml</span>
      </li>
    </ul>

    <span class="input">
      เติม sodium ด้วย
      <input class="input" type="radio" v-model="n2" value="3" />
      <label for="3">3%NaCl</label>
      <input type="radio" v-model="n2" value="20" />
      <label for="20">20%NaCl</label>
    </span>

    <div class="highlight">
      <br />
      <b>📄 ขั้นตอนการเตรียม</b>
      <br />
      <span class="desc"
        >ได้ความเข้มข้นสุดท้าย Dextrose {{ dextrose.toFixed(1) }}%, NaCl
        {{ naclcalc.toFixed(2) }}%</span
      >
      <ol id="sop">
        <li>นำน้ำเกลือ {{ d1 }}%D{{ nacllabel }} มา {{ vt }} ml</li>
        <li>ดูดน้ำเกลือออก {{ voldrawcalc }} ml</li>
        <li>เติม 50%Dextrose {{ v50dcalc }} ml ลงไปในขวดน้ำเกลือ</li>
        <li>
          เติม {{ n2 }}%NaCl {{ vnaclcalc }} ml ลงไปในขวดน้ำเกลือ จะได้น้ำเกลือ
          {{ d2 }}%D{{ ntlabel }} {{ vt }} ml
        </li>
      </ol>
    </div>
    <b>Reference</b>
    <ol id="sop">
      <li>
        <a
          href="https://www.competencyrx.com/index.php/%E0%B9%80%E0%B8%A0%E0%B8%AA%E0%B8%B1%E0%B8%8A%E0%B8%81%E0%B8%A3%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%84%E0%B8%B3%E0%B8%99%E0%B8%A7%E0%B8%93/60-%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%84%E0%B8%B3%E0%B8%99%E0%B8%A7%E0%B8%93%E0%B8%AA%E0%B8%B2%E0%B8%A3%E0%B8%A5%E0%B8%B0%E0%B8%A5%E0%B8%B2%E0%B8%A2"
          >การคำนวณสารละลาย</a
        >
      </li>
      <li>
        <a
          href="https://kc-hospital.net/sites/default/files/%E0%B8%99%E0%B9%89%E0%B8%B3%E0%B9%80%E0%B8%81%E0%B8%A5%E0%B8%B7%E0%B8%AD.pdf"
        >
          แนวทางการเตรียมสารน้ำชนิด Dextrose
          ในความเข้มนอกเหนือที่มีในบัญชียาโรงพยาบาล</a
        >
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: "advcalc",
  data() {
    return {
      d1: 5,
      d2: 10,
      vt: 1000,
      nacl: 0.9,
      nt: 0.9,
      n2: 20,
    };
  },
  computed: {
    dextrose() {
      return (
        (50 * this.v50dcalc +
          this.d1 * (this.vt - (this.vnaclcalc + this.v50dcalc))) /
        this.vt
      );
    },
    naclcalc() {
      return (
        (this.n2 * this.vnaclcalc +
          this.nacl * (this.vt - (this.vnaclcalc + this.v50dcalc))) /
        this.vt
      );
    },
    voldrawcalc() {
      return this.v50dcalc + this.vnaclcalc;
    },
    vnaclcalc() {
      return Math.round(
        ((this.nt - this.nacl) * this.vt + this.v50dcalc * this.nacl) /
          (this.n2 - this.nacl)
      );
    },
    v50dcalc() {
      return Math.round(
        ((this.nt - this.nacl) * this.vt * -this.nacl -
          (this.d2 - this.d1) * this.vt * (this.n2 - this.nacl)) /
          ((50 - this.d1) * (this.nacl - this.n2)) -
          this.nacl * this.d1
      );
    },
    ntlabel() {
      if (this.nt >= 0.9) {
        return "S";
      } else if (this.nt >= 0.45) {
        return "N/2";
      } else if (this.nt >= 0.3) {
        return "N/3";
      } else if (this.nt >= 0.225) {
        return "N/4";
      } else if (this.nt >= 0.18) {
        return "N/5";
      } else {
        return "W";
      }
    },
    nacllabel() {
      if (this.nacl >= 0.9) {
        return "S";
      } else if (this.nacl >= 0.45) {
        return "N/2";
      } else if (this.nacl >= 0.3) {
        return "N/3";
      } else if (this.nacl >= 0.225) {
        return "N/4";
      } else if (this.nacl >= 0.18) {
        return "N/5";
      } else {
        return "W";
      }
    },
  },
};
</script>

<style scope>
ul#menu li {
  display: inline;
  text-align: center;
}
ol#sop li {
  display: list-item;
}
h3#topic {
  font-size: 16px;
  margin-bottom: 2px;
}
img {
  height: 30px;
  vertical-align: bottom;
}

.input {
  font-size: 18px;
  text-align: center;
  color: #364f6b;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px thin #4f9bb2;
}
</style>
